import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Typography } from "@mui/material"
import { getCompactFormattedNumber } from "app/tools/number"
import { IInventoryMapButtonProps } from "form/inventory/model"

import React from "react"
import { FlexBox } from "ui/components/FlexBox"
import { ThreeDotLoader } from "ui/components/ThreeDotLoader"
import { setInventoryMapVisibility } from "../tools/inventory"

export const InventoryMapButton = React.memo(
  ({ viewType, count, label, icon, isActive, isRefreshing }: IInventoryMapButtonProps) => (
    <FlexBox
      sx={{
        "position": "relative",
        "cursor": "pointer",
        "pl": "1rem",
        "pr": "1rem",
        "height": "1.8rem",
        "& > *": {
          zIndex: 1
        },
        "& .inventory-icon": {
          mr: ".5rem",
          color: theme => (isActive ? theme.palette.specialText : theme.palette.text.primary)
        }
      }}
      onClick={event => {
        event.stopPropagation()
        event.preventDefault()
        setInventoryMapVisibility(true, viewType)
      }}>
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          minWidth: "100%",
          maxWidth: "100%",
          height: "100%",
          minHeight: "100%",
          maxHeight: "100%",
          top: 0,
          backgroundColor: theme => (isActive ? theme.palette.primary.main : theme.palette.background.paper),
          transform: "skew(-10deg)",
          zIndex: "0 !important"
        }}
        className="inventory-button-background"
      />
      <FontAwesomeIcon icon={icon} className="inventory-icon" size="1x" />
      {isRefreshing ? (
        <ThreeDotLoader sx={{ transform: "scale(.5)", marginLeft: ".5rem" }} />
      ) : (
        <Typography
          sx={{
            color: theme => (isActive ? theme.palette.specialText : theme.palette.text.primary),
            fontSize: ".9rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
          {getCompactFormattedNumber(count)} {label}
        </Typography>
      )}
    </FlexBox>
  )
)
